export default "__VITE_ASSET__BE9CB9Go__"